export default __webpack_public_path__ + "static/media/coreos-icon.5aa1bcb6.svg";